import { isEmpty } from 'lodash'
import { Field, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

import RadioButton from 'components/RadioButton'
import Badge from 'components/Badge'

import { getAllConfigurationModels } from 'store/ConfigurationModels/selectors'
import {
  getDisplayConfigurationModelName,
  getMenuModelDescription,
  getPickupForConcessions,
} from 'utils/revenueCenters'

const MenuModel = ({
  setSelectedMenuServiceType,
  currentMenu,
  menuIndex,
  showValidationErrors,
  isNewMenu,
}) => {
  const { setFieldValue, initialValues } = useFormikContext()

  const { serviceType, configurationModelId } = currentMenu ?? {
    serviceType: '',
    configurationModelId: '',
  }

  const configurationModels = useSelector(getAllConfigurationModels)

  const initialValueConfigurationModelId = initialValues?.menus?.find(
    ({ uuid }) => uuid === currentMenu?.uuid
  )?.configurationModelId

  const isLegacyServiceType =
    !isEmpty(serviceType) && isEmpty(initialValueConfigurationModelId)

  const getMenuModelPlaceholder = (
    name,
    organizationName,
    venueUuid
  ) => {
    const isCustom = !isEmpty(organizationName) && !isEmpty(venueUuid)

    return (
      <div className="menu-model-row__label">
        <span>{getDisplayConfigurationModelName(name)}</span>
        {isCustom && <Badge label="custom" />}
      </div>
    )
  }

  const menuModelDescription = getMenuModelDescription(
    isNewMenu,
    initialValueConfigurationModelId
  )

  const handleClickConfigurationModel = (uuid, name) => {
    setFieldValue(`menus.${menuIndex}.configurationModelId`, uuid)
    setFieldValue(`menus.${menuIndex}.configurationModelName`, name)
  }

  return (
    <div className="content-wrapper -flags-wrapper -block">
      <h3 className="header-title">Menu Model</h3>
      <div className="description padding-bottom-sm">
        {menuModelDescription}
      </div>
      {isLegacyServiceType && (
        <div className="content-wrapper -block">
          <div className="info-row info-row--styled">
            <span>Legacy Service Type Selected</span>
            <span>{getPickupForConcessions(serviceType ?? '')}</span>
          </div>
        </div>
      )}
      {configurationModels?.map(
        ({
          name,
          uuid,
          organizationName,
          venueUuid,
          serviceType,
        }) => (
          <div className="menu-model-row" key={uuid}>
            <Field
              component={RadioButton}
              name={`menus.${menuIndex}.configurationModelId`}
              placeholder={getMenuModelPlaceholder(
                name,
                organizationName,
                venueUuid
              )}
              type="radio"
              checked={configurationModelId === uuid}
              onClick={() => {
                handleClickConfigurationModel(uuid, name)
                setSelectedMenuServiceType(serviceType)
              }}
              showValidationErrors={showValidationErrors}
              inputClassName="-sm"
            />
          </div>
        )
      )}
    </div>
  )
}

export default MenuModel
